// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-dob {
  margin: 0px;
}
.grid-dob ion-col {
  border: solid 1px #fff;
  text-align: center;
}

.dob-section ion-select {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/boyd-rewards/boyd-rewards-connect/boyd-rewards-connect.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,sBAAA;EACA,kBAAA;AACR;;AAII;EACI,kBAAA;AADR","sourcesContent":[".grid-dob {\n    margin: 0px;\n\n    ion-col {\n        border: solid 1px #fff;\n        text-align: center;\n    }\n}\n\n.dob-section {\n    ion-select {\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
